import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Select, MenuItem, FormControl } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';

export const DarkModeToggle = () => {
  const { mode, setMode } = useColorScheme();

  if (!mode) {
    return null;
  }

  return (
    <FormControl size="small">
      <Select
        value={mode}
        onChange={(event) =>
          setMode(event.target.value as 'system' | 'light' | 'dark')
        }
      >
        <MenuItem value="system">
          <FormattedMessage id="dark_mode.system" defaultMessage="System" />
        </MenuItem>
        <MenuItem value="light">
          <FormattedMessage id="dark_mode.light" defaultMessage="Světlý" />
        </MenuItem>
        <MenuItem value="dark">
          <FormattedMessage id="dark_mode.dark" defaultMessage="Tmavý" />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
